module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-17.dec8e1ab.png";